import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkOrderTaskComponent } from './work-order-task.component';
import { TaskListModule } from '../../../../task/task-list/task-list.module';

@NgModule({
  imports: [
    CommonModule,
    TaskListModule
  ],
  declarations: [WorkOrderTaskComponent],
  exports: [WorkOrderTaskComponent]
})
export class WorkOrderTaskModule { }
